import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import OutlinedPageBox from '../global/OutlinedPageBox';
import CenteredContentLayout from '../global/CenteredContentLayout';

function QueueError({
  onRetry,
  isRetrying,
}: {
  onRetry: () => void;
  isRetrying?: boolean;
}) {
  return (
    <OutlinedPageBox>
      <CenteredContentLayout
        image={ErrorOutlineIcon}
        title="We couldn't load your walk-in queue"
        description="Something went wrong while loading the queue. Please try again."
        button={{
          text: 'Try Again',
          onClick: onRetry,
          loading: isRetrying,
        }}
        maxWidth="750px"
      />
    </OutlinedPageBox>
  );
}

export default QueueError;
